<template>
  <Scatter
    :options="computedChartOptions"
    :data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :width="width"
    :height="height"
    data-test-name="scatter-chart"
    data-test-variant=""
    data-test-state=""
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { Scatter } from 'vue-chartjs'
import * as ChartJS from 'chart.js'
import { cloneDeep, merge } from 'lodash-unified'
import { getChartDefaultOptions } from './utils'
import type { ChartData, ChartOptions, Plugin } from 'chart.js'
import type { PropType } from 'vue'

const {
  CategoryScale,
  Chart,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
} = ChartJS
Chart.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement
)

defineOptions({ name: 'BScatterChart' })

const props = defineProps({
  chartId: {
    type: String,
    default: 'scatter-chart',
  },
  datasetIdKey: {
    type: String,
    default: 'label',
  },
  width: {
    type: Number,
    default: 480,
  },
  height: {
    type: Number,
    default: 240,
  },
  plugins: {
    type: Array as PropType<Plugin<'scatter'>[]>,
    default: () => [],
  },
  chartData: {
    type: Object as PropType<ChartData<'scatter', number[], unknown>>,
    default: () => ({ datasets: [] }),
  },
  chartOptions: {
    type: Object as PropType<ChartOptions<'scatter'>>,
    default: () => ({ responsive: true, maintainAspectRatio: true }),
  },
})

const defaultOptions = cloneDeep(
  getChartDefaultOptions('scatter')
) as ChartOptions<'scatter'>

const computedChartOptions = computed(() =>
  merge(defaultOptions, props.chartOptions)
)
</script>
